// Pill-style language switcher (parent + kids React apps).
// Same shape as apps/web/src/components/LanguageSwitcher.astro. The caller
// owns navigation — pass `arHref` and `enHref` that resolve to the right
// route for the current page.

import { cn } from './cn';

export interface LanguageSwitcherProps {
  locale: 'ar' | 'en';
  arHref: string;
  enHref: string;
  arLabel: string;
  enLabel: string;
  ariaLabel: string;
  className?: string;
}

export function LanguageSwitcher({
  locale,
  arHref,
  enHref,
  arLabel,
  enLabel,
  ariaLabel,
  className,
}: LanguageSwitcherProps) {
  return (
    <div
      role="group"
      aria-label={ariaLabel}
      className={cn(
        'inline-flex items-center gap-1 rounded-full bg-cream-100 p-1 ring-1 ring-burgundy-500/10',
        className,
      )}
    >
      <a
        href={arHref}
        hrefLang="ar"
        aria-current={locale === 'ar' ? 'true' : undefined}
        rel={locale === 'ar' ? undefined : 'alternate'}
        className={cn(
          'rounded-full px-3 py-1 text-sm font-semibold transition-colors',
          locale === 'ar'
            ? 'bg-burgundy-500 text-cream-50'
            : 'text-burgundy-500 hover:bg-cream-200',
        )}
      >
        {arLabel}
      </a>
      <a
        href={enHref}
        hrefLang="en"
        aria-current={locale === 'en' ? 'true' : undefined}
        rel={locale === 'en' ? undefined : 'alternate'}
        className={cn(
          'rounded-full px-3 py-1 text-sm font-semibold transition-colors',
          locale === 'en'
            ? 'bg-burgundy-500 text-cream-50'
            : 'text-burgundy-500 hover:bg-cream-200',
        )}
      >
        {enLabel}
      </a>
    </div>
  );
}
